export default "__VITE_ASSET__21f1864f__"